import { isValidPassword } from "@iscr/xAppLib/Users/passwordValidation";
import { validateDVANumber, validateDVAColour } from './dvaValidation';
import { field_mobile, field_full_address } from '@iscr/models/user_model';
import moment from 'moment';

export const validateAuthFields = (formData) => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email || !emailRegex.test(formData.email)) {
        errors.email = 'Please enter a valid email address';
    }

    if (!formData.password || !isValidPassword(formData.password)) {
        errors.password = 'Password does not meet all requirements';
    }

    if (formData.password !== formData.confirmPassword) {
        errors.confirmPassword = 'Passwords do not match';
    }

    if (!formData.firstName?.trim()) {
        errors.firstName = 'Please enter your first name';
    }
    if (!formData.lastName?.trim()) {
        errors.lastName = 'Please enter your last name';
    }

    if (!formData.consent) {
        errors.consent = 'You must agree to the terms to create an account';
    }

    if ('captcha' in formData && !formData.captcha) {
        errors.captcha = true;
    }

    return errors;
};

export const validateDOBField = (val) => {
   return   val && /\d{4}\-\d{2}\-\d{2}/.test(val) && moment(val).isValid() 
            && moment().diff(val, 'years') >= 0 && moment().diff(val, 'years') <= 120
}

export const validateDVAFields = (dvaNumber) => {
    const errors = {};
    const hasDVANumber = Boolean(dvaNumber?.number?.trim());
    const hasDVAColour = Boolean(dvaNumber?.colour);

    if (hasDVANumber || hasDVAColour) {
        if (!hasDVANumber) {
            errors.number = 'Please enter a DVA number';
        } else if (!validateDVANumber(dvaNumber.number)) {
            errors.number = 'Please enter a valid DVA number';
        }

        if (!hasDVAColour) {
            errors.colour = 'Please select a card colour';
        } else if (!validateDVAColour(dvaNumber.colour)) {
            errors.colour = 'Please select a valid card colour';
        }
    }

    return errors;
};

export const validateAccountDetails = (formData) => {
    const errors = { ...validateDVAFields(formData.dvaNumber) };

    if (!formData.dateOfBirth) {
        errors.dateOfBirth = 'Please enter your date of birth';
    } else if (!validateDOBField(formData.dateOfBirth)) {
        errors.dateOfBirth = 'Please enter a valid date of birth';
    }

    if (!formData.sex) {
        errors.sex = 'Please select your sex assigned at birth';
    }

    if (!formData.mobilePhone || !field_mobile.pattern.test(formData.mobilePhone)) {
        errors.mobilePhone = 'Please enter a valid mobile phone number';
    }

    if (!formData.full_address) {
        errors.full_address = 'Please enter your address';
    } else if (!field_full_address.validate_function(formData.full_address)) {
        errors.full_address = field_full_address.validation_message(formData.full_address);
    }

    return errors;
};